import { render, staticRenderFns } from "./teachBuild.vue?vue&type=template&id=7b0ad8c8&"
import script from "./teachBuild.vue?vue&type=script&lang=js&"
export * from "./teachBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports